<template>
<div class="BigBox" >
<div class="logo">
  <router-link to="BaiDu02"><img src="../../assets/images/image01.gif" alt=""></router-link>
</div>
  <div class="search">
    <input type="text">
    <input type="button" value="百度一下">
    <img src="../../assets/images/相机1.png">
  </div>
</div>
</template>

<script>
export default {
  name: "SearchBox"
}
</script>
<style scoped lang="scss">
.BigBox{
  margin: 0 auto;
  position: relative;
  z-index: 10;
}
.logo{
  width: 400px;
  height: 200px;
  /*background: #42b983;*/
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.logo img{
  width: 270px;
  height: 129px;
}
.search{
  width: 670px;
  height: 60px;
  /*background: #42b983;*/
  margin: -46px auto;
  position: relative;
}
.search input:first-child{
  width: 550px;
  height: 43px;
  border-radius: 10px 0 0 10px;
  border: 2px solid #c4c7ce;
  position: relative;
  font-size: 16px;
  padding-right: 40px;
  padding-left: 15px;
  outline: none;
}
.search input:nth-child(2){
  width: 108px;
  height: 43px;
  background:#315efb;
  border-radius: 0 10px 10px 0;
  border: none;
  font-size: 20px;
  color: #fff;
  position: relative;
  top:2px
}
.search img{
  width: 26px;
  height: 26px;
  position: absolute;
  right: 130px;
  top:10px;

}


</style>